const totalscreenType = [
  {
    type: 'engagement',
    stateValue: 'eng',
    title: 'Engagements',
    dashboardPath: '/engagement/dashboard',
    createPath: '/engagement/create',
    editPath: '/engagement/edit',
    draftPath: '/engagement/draft',
    draftDashboardPath: '/screens-draft',
    draft: { label: 'Engagement', value: 'engagement' },
  },
  {
    type: 'aiengagement',
    stateValue: 'aieng',
    title: 'AI engagements',
    dashboardPath: '/aiengagement/dashboard',
    createPath: '/agents/create',
  },
  {
    type: 'cta',
    stateValue: 'cta',
    title: 'CTA',
    dashboardPath: '/cta/dashboard',
    createPath: '/cta/create',
    editPath: '/cta/edit',
    draftPath: '/cta/draft',
    draftDashboardPath: '/screens-draft',
    draft: { label: 'CTA', value: 'action' },
  },
  {
    type: 'endscreen',
    stateValue: 'endScreen',
    title: 'End screens',
    dashboardPath: '/endscreen/dashboard',
    createPath: '/endscreen/create',
    editPath: '/endscreen/edit',
    draftPath: '/endscreen/draft',
    draftDashboardPath: '/screens-draft',
    draft: { label: 'End screen', value: 'endScreen' },
  },
  {
    type: 'screens-draft',
    title: 'Screen drafts',
  },
  {
    type: 'recirculations',
    stateValue: 'collectionsV1',
    title: 'Recirculation',
    createLabel: 'recirculation',
    dashboardPath: '/recirculations/dashboard',
    createPath: '/recirculations/create',
    overviewPath: '/recirculations/overview',
  },
  {
    type: 'collections',
    stateValue: 'collectionsV2',
    title: 'Event Database',
    createLabel: 'collection',
    dashboardPath: '/collections/dashboard',
    createPath: '/collections/create',
  },
];

export default totalscreenType;
